import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿En qué formato recibo el material?',
    a: '100% digital: PDF descargables listos para usar.'
  }, {
    q: '¿Puedo imprimir los cuadernillos?',
    a: 'Sí, sin restricciones.'
  }, {
    q: '¿Para qué grados sirve?',
    a: 'De 1.º a 6.º grado de primaria.'
  }, {
    q: '¿Necesito materiales especiales?',
    a: 'No. Está diseñado para recursos accesibles y habituales en primaria.'
  }, {
    q: '¿Cuánto tarda en llegar?',
    a: 'Acceso inmediato tras la compra.'
  }];
  return <section className="bg-gray-50 py-16 px-4 md:px-8" data-id="element-40">
      <div className="max-w-3xl mx-auto" data-id="element-41">
        <h2 className="text-3xl font-black text-center text-gray-900 mb-12" data-id="element-42">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-43">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-44" />)}
        </div>

        <div className="mt-16 text-center" data-id="element-45">
          <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-46">
            ¿Lista para transformar tu año escolar?
          </h3>
          <p className="text-xl text-gray-600 mb-8" data-id="element-47">
            Unite a cientos de maestras que ya organizaron su año sin estrés.
          </p>
          <a href="#compra" className="inline-block bg-green-600 hover:bg-green-700 text-white text-2xl font-bold py-5 px-10 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 animate-pulse" data-id="element-48">
            👉 QUIERO EMPEZAR AHORA
          </a>
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-49">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-50">
        <span className="font-bold text-gray-900 text-lg" data-id="element-51">{question}</span>
        {isOpen ? <ChevronUp className="text-gray-500" data-id="element-52" /> : <ChevronDown className="text-gray-500" data-id="element-53" />}
      </button>
      {isOpen && <div className="px-5 pb-5 text-gray-700" data-id="element-54">{answer}</div>}
    </div>;
}